import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { deleteRequest } from '../../requestUtils';
import { interviewAvailabilityShape } from '../../dateUtils';
import { analyticsTrack } from '../../analyticsUtils';
import InterviewAttendees from '../common/InterviewSubComponents/InterviewAttendees';
import InterviewTimeRange from '../common/InterviewSubComponents/InterviewTimeRange';
import InterviewTimezone from '../common/InterviewSubComponents/InterviewTimezone';
import InterviewMeetingDetails from '../common/InterviewSubComponents/InterviewMeetingDetails';
import InterviewActions from '../common/InterviewSubComponents/InterviewActions';
import './InterviewPanel.scss';
var interviewHeaderOpts = {
  timeZone: 'UTC',
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  year: 'numeric'
};
var availabilityOpts = {
  timeZone: 'UTC',
  weekday: 'long',
  month: 'short',
  day: 'numeric'
};
var MIN_AVAILABILITY_LEN = 1;

// This component is not very aptly named - used on Interview#show page
// Meanwhile, the Interview.jsx component would probably be better called
// InterviewPanel or InterviewBadge.
var InterviewPanel = /*#__PURE__*/function (_React$Component) {
  function InterviewPanel(props) {
    var _this;
    _classCallCheck(this, InterviewPanel);
    _this = _callSuper(this, InterviewPanel, [props]);
    _this.state = {
      isViewingMore: false,
      showCancellationCopy: false,
      interview: _this.props.interview
    };
    _this.handleInterviewMeetingDetailsSubmit = _this.handleInterviewMeetingDetailsSubmit.bind(_this);
    _this.backToMyInterviewsPath = "".concat(_this.props.myInterviewsPath, "?type=").concat(_this.props.interview.type);
    _this.location = 'Interview Page View';
    return _this;
  }
  _inherits(InterviewPanel, _React$Component);
  return _createClass(InterviewPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      analyticsTrack('Interview Page Viewed', {});
    }
  }, {
    key: "getAvailabilities",
    value: function getAvailabilities() {
      var _this$state = this.state,
        isViewingMore = _this$state.isViewingMore,
        interview = _this$state.interview;
      if (isViewingMore) {
        return interview.availabilities;
      }
      return interview.availabilities.slice(0, MIN_AVAILABILITY_LEN); // only show the first
    }
  }, {
    key: "handleCancelInterview",
    value: function handleCancelInterview() {
      var _this2 = this;
      var _this$props = this.props,
        cancelInterviewPath = _this$props.cancelInterviewPath,
        csrfToken = _this$props.csrfToken,
        interviewResourceId = _this$props.interviewResourceId,
        interview = _this$props.interview;
      var analyticsMessage = "Interview cancelled; type: ".concat(interview.type);
      deleteRequest(cancelInterviewPath, csrfToken).then(function () {
        analyticsTrack(analyticsMessage, {
          location: _this2.location
        });
        var newUrl = "".concat(_this2.backToMyInterviewsPath, "&cancelled_interview=").concat(interviewResourceId);
        window.location.href = newUrl;
      });
    }
  }, {
    key: "handleInterviewMeetingDetailsSubmit",
    value: function handleInterviewMeetingDetailsSubmit(response) {
      this.setState({
        interview: response.data
      });
    }
  }, {
    key: "renderInterviewHeader",
    value: function renderInterviewHeader() {
      var _this$props2 = this.props,
        projectName = _this$props2.projectName,
        projectUrl = _this$props2.projectUrl;
      var interview = this.state.interview;
      if (interview.accepted_time) {
        return /*#__PURE__*/React.createElement("div", {
          className: "interview-panel-header mt-3"
        }, /*#__PURE__*/React.createElement(InterviewTimeRange, {
          interviewTime: interview.accepted_time,
          opts: interviewHeaderOpts,
          containerClassName: "d-inline-block body-text-1 medium-weight"
        }), /*#__PURE__*/React.createElement("div", {
          className: "d-inline-block ms-2 body-text-3 muted-gray-text"
        }, /*#__PURE__*/React.createElement(InterviewTimezone, {
          timezoneStr: interview.timezone,
          dateStr: interview.accepted_time.date
        })), /*#__PURE__*/React.createElement("div", {
          className: "mt-3"
        }, /*#__PURE__*/React.createElement("div", {
          className: "body-text-1 medium-weight interview-candidate-and-round mb-4"
        }, "Interview with", ' ', interview.attendees.consultant, ' ', "(Round", ' ', interview.round_number, ")"), /*#__PURE__*/React.createElement("a", {
          href: projectUrl,
          className: "body-text-2 normal-weight project-name"
        }, projectName)));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "interview-panel-header mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-1 medium-weight interview-candidate-and-round mb-4"
      }, "Interview pending ".concat(interview.type === 'pending' ? ' confirmation' : ' reschedule')), /*#__PURE__*/React.createElement("a", {
        href: projectUrl,
        className: "body-text-2 normal-weight project-name"
      }, projectName));
    }
  }, {
    key: "renderViewMore",
    value: function renderViewMore(className) {
      var _this3 = this;
      var viewMoreCta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'View More';
      var viewLessCta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'View Less';
      var cta = this.state.isViewingMore ? viewLessCta : viewMoreCta;
      return /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this3.setState({
            isViewingMore: !_this3.state.isViewingMore
          });
        },
        role: "button",
        tabIndex: "0",
        className: "view-more-cta ".concat(className)
      }, cta);
    }
  }, {
    key: "renderUpcomingInterviewSubDivider",
    value: function renderUpcomingInterviewSubDivider() {
      var _this$props3 = this.props,
        editInterviewPath = _this$props3.editInterviewPath,
        isRep = _this$props3.isRep,
        csrfToken = _this$props3.csrfToken;
      var _this$state2 = this.state,
        interview = _this$state2.interview,
        isViewingMore = _this$state2.isViewingMore;
      var meetingDetails = interview.meeting_details;
      if (meetingDetails) {
        return /*#__PURE__*/React.createElement("div", {
          className: "upcoming-interview-sub-divider-section"
        }, this.renderViewMore('body-text-2 medium-weight mb-2', 'Show meeting details', 'Hide meeting details'), isViewingMore && /*#__PURE__*/React.createElement(InterviewMeetingDetails, {
          isRep: isRep,
          meetingDetails: meetingDetails,
          csrfToken: csrfToken,
          editInterviewPath: editInterviewPath,
          onSubmit: this.handleInterviewMeetingDetailsSubmit
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "upcoming-interview-sub-divider-section"
      }, /*#__PURE__*/React.createElement(InterviewMeetingDetails, {
        isRep: isRep,
        meetingDetails: meetingDetails,
        csrfToken: csrfToken,
        editInterviewPath: editInterviewPath,
        onSubmit: this.handleInterviewMeetingDetailsSubmit
      }));
    }
  }, {
    key: "renderPendingInterviewSubDivider",
    value: function renderPendingInterviewSubDivider() {
      var _this4 = this;
      var interview = this.state.interview;
      var availabilitiesToRender = this.getAvailabilities();
      return /*#__PURE__*/React.createElement("div", {
        className: "pending-interview-sub-divider-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 normal-weight mb-4"
      }, interview.attendees.consultant.split(' ')[0], ' ', "did not select a time yet. All guests will be notified when a time is selected."), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 medium-weight mb-8"
      }, "Your availability for this interview:"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 muted-gray-text mb-8"
      }, /*#__PURE__*/React.createElement(InterviewTimezone, {
        timezoneStr: interview.timezone
      })), /*#__PURE__*/React.createElement("div", {
        className: "interview-panel-availabilities body-text-2"
      }, availabilitiesToRender.map(function (availability, i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "availability-range-container",
          key: "".concat(availability.start_time).concat(availability.date)
        }, /*#__PURE__*/React.createElement(InterviewTimeRange, {
          interviewTime: availability,
          opts: availabilityOpts,
          containerClassName: "interview-availability-item normal-weight mb-4"
        }), i === availabilitiesToRender.length - 1 && _this4.renderViewMore('ms-3 medium-weight'));
      })));
    }
  }, {
    key: "renderInterviewSubDivider",
    value: function renderInterviewSubDivider() {
      var interview = this.state.interview;
      if (interview.type === 'past') {
        return null;
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("hr", {
        className: "width-180"
      }), interview.type === 'upcoming' && this.renderUpcomingInterviewSubDivider(), interview.type === 'pending' && this.renderPendingInterviewSubDivider());
    }
  }, {
    key: "renderInterviewPanelActions",
    value: function renderInterviewPanelActions() {
      var _this5 = this;
      var interview = this.state.interview;
      var _this$props4 = this.props,
        editInterviewPath = _this$props4.editInterviewPath,
        csrfToken = _this$props4.csrfToken,
        possibleInterviewers = _this$props4.possibleInterviewers,
        invitableRoles = _this$props4.invitableRoles,
        canEdit = _this$props4.canEdit,
        canCancel = _this$props4.canCancel;
      if (interview.type === 'past') {
        // nothing to render for past interviews
        return null;
      }
      if (!canEdit && !canCancel) {
        // if no action can be taken -
        return null;
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("hr", {
        className: "actions-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "action-container g-row--always g-row-justify-right"
      }, /*#__PURE__*/React.createElement(InterviewActions, {
        editInterviewPath: editInterviewPath,
        csrfToken: csrfToken,
        possibleInterviewers: possibleInterviewers,
        invitableRoles: invitableRoles,
        interview: interview,
        interviewType: interview.type,
        location: this.location,
        canEdit: canEdit,
        canCancel: canCancel,
        onCancel: function onCancel() {
          return _this5.handleCancelInterview();
        }
      })));
    }
  }, {
    key: "renderBackButton",
    value: function renderBackButton() {
      return /*#__PURE__*/React.createElement("a", {
        href: this.backToMyInterviewsPath,
        role: "button",
        tabIndex: "0",
        className: "body-text-1 medium-weight"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-angle-left me-3"
      }), "Back to My Interviews");
    }
  }, {
    key: "render",
    value: function render() {
      var interview = this.state.interview;
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide card mb-0 border-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container interview-info-card"
      }, this.renderBackButton(), this.renderInterviewHeader(), /*#__PURE__*/React.createElement(InterviewAttendees, {
        attendees: interview.attendees,
        horizontal: true
      }), this.renderInterviewSubDivider()), this.renderInterviewPanelActions());
    }
  }]);
}(React.Component);
InterviewPanel.propTypes = {
  interview: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    round_number: PropTypes.number,
    accepted_time: interviewAvailabilityShape,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    invited_emails: PropTypes.arrayOf(PropTypes.string),
    timezone: PropTypes.string
  }).isRequired,
  myInterviewsPath: PropTypes.string.isRequired,
  cancelInterviewPath: PropTypes.string.isRequired,
  editInterviewPath: PropTypes.string.isRequired,
  projectName: PropTypes.string.isRequired,
  projectUrl: PropTypes.string.isRequired,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  csrfToken: PropTypes.string.isRequired,
  isRep: PropTypes.bool,
  interviewResourceId: PropTypes.string.isRequired,
  canEdit: PropTypes.bool,
  canCancel: PropTypes.bool
};
InterviewPanel.defaultProps = {
  isRep: false,
  canEdit: false,
  canCancel: false
};
export default InterviewPanel;